<template>
    <div>
        <div v-if="$store.state.status == null" class="popup profile-wrap">
            <vue-headful  title="Forgot Password | bilasrka.is"  description="Forgot"  />
            <div class="title"> Forgot password
                <div class="close">
                    <a @click.prevent="closePopup()"><img src="/img/profile/close-x.svg" /></a>
                </div>
            </div>
            <hr class="hr" />
            <div class="forgot-text">
                Enter the email address associated with your account,<br /> and we’ll send you a
                link to reset your password.
            </div>
            <div class="popup-body">
                <div class="form-group">
                    <div class="field-wrapper">  <!--:class="{'filled-label':email && email.length > 0}"-->
                        <input class="form-control" type="text" v-validate="'required|email'" name="email" v-model="email" />
                        <label :class="{ 'filled-label': email && email.length > 0 }" :for="name">Email</label>
                        <div v-show="errors.has('email')" class="error"> {{ errors.first("email") }}</div>
<!--                        <div v-if="error['email']" class="error">{{ error["email"] }}</div>-->
                    </div>
                </div>
                <div style="clear: both;"></div>
                <div class="form-group forgot-form-group" style="margin-top: 25px;">
                    <div class="forgot-btn-holder">
                        <btn @click.native="validateForm()" class="btn btn-success" :load="load">Send reset link</btn>
                        <!-- <div @click="forgot" class="btn btn-success">Send reset link</div>-->
                    </div>
                </div>
            </div>
            <hr class="hr" />
            <div class="footer">
                <a href="#" @click.prevent="$store.state.popup='sign-in'">Back to Sign in</a>
            </div>
        </div>
        <pop-up v-if="$store.state.status == 'success'" :title="'Password reset link send'"
                :desc="'We send you e-mail plaese ckick on the link to set new password'"
                :btn="{ title: 'Go to sign in', url: '/sign-in' }" :icon="'email.svg'"></pop-up>
    </div>
</template>

<script>
    import PopUp from "./PopUpSuccess.vue";
    import PreloadBtn from "../PreloadBtn.vue";

    export default {
        data: function () {
            return {
                // error: [],
                email: "",
                load: false,
                name: ""
            };
        },
        components: {
            PopUp,
            btn: PreloadBtn
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(result => {
                    if (result){
                        return this.forgot();
                    }
                });
            },
            closePopup: function () {
                if (this.$route.path == "/sign-in") {
                    this.$router.push("/");
                } else {
                    this.$store.state.popup = null;
                }
            },
            // validateEmail: function (email) {
            //     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            //     return re.test(String(email).toLowerCase());
            // },
            forgot: function () {
                // this.error = {};
                // if (!this.email) {
                //     this.error.email = "email is required";
                // }
                //
                // if (this.email && !this.validateEmail(this.email)) {
                //     this.error.email = "Email incorrect";
                // }

                // if (!Object.keys(this.error).length && !this.load) {
                    var d = new FormData();
                    // d.set("_csrf", document.querySelector("meta[name=csrf-token]").content);
                    d.set("email", this.email);

                    this.load = true;
                    let api = this.$store.state.api;
                    this.$http
                        .post(`${api}/user/forgot`, d)
                        .then(function (response) {
                            this.load = false;
                            if (response.body.error) {
                                // let resp = [];
                                for (let k in response.body.error) {
                                    let s = "";


                                    // console.log(response.body.error[k]);
                                    // console.log(typeof(response.body.error[k]) == "object");

                                    if (typeof response.body.error[k] == "object") {
                                        for (let kk in response.body.error[k]) {
                                            s += response.body.error[k][kk];
                                            this.$validator.errors.add({
                                                field: k,
                                                msg: s
                                            });
                                        }
                                        // console.log(response.body.error[k], typeof (response.body.error[k]));
                                    }else{
                                        this.$validator.errors.add({
                                            field: k,
                                            msg: response.body.error[k]
                                        });
                                    }
                                    // resp[k] = s;
                                }
                                // th.errors = resp;
                            }

                            if (response.body.status == "OK") {
                                this.$store.state.status = "success";
                            }
                        })
                        .catch(function (response) {

                        });
                // }
            }
        }
    };
</script>
